import { useSelector } from 'react-redux'
import type { State } from '../../Flux/Slice/index.js'
import type { ModalPropsMap, ModalTypeName } from './ModalMap.js'
import { MODAL_COMPONENTS } from './ModalMap.js'
import React from 'react'
import { useModal } from './UseModal.js'

/**
 * The global component to be injected into the page layout, which hosts the actual modal rendering.
 * Only one modal is allowed to be open at a time right now
 *
 * @constructor
 */
export const GlobalModalHost = () => {
  const stack = useSelector((state: typeof State) => state.modal.stack)
  const { closeModal } = useModal()

  if (stack.length === 0) return null

  type ComponentMap = typeof MODAL_COMPONENTS

  return (
    <>
      {stack.map(({ modalType, props }, index) => {
        const Component = MODAL_COMPONENTS[modalType as keyof ComponentMap] as React.FC<
          ModalPropsMap[typeof modalType & ModalTypeName] & { isOpen: boolean; onClose: (result?: undefined) => void }
        >

        const handleResolve = (result: unknown) => {
          closeModal(result)
        }

        const isTop = index === stack.length - 1

        return <Component key={index} {...props} isOpen={isTop} onClose={handleResolve} />
      })}
    </>
  )
}
